module.exports = __webpack_public_path__ + "img/fish-filet.e15267b0.png";